module.exports = __webpack_public_path__ + "static/media/none.f44ff021.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/giftcard/none.png
// module id = 1859
// module chunks = 6